<div class="title">
    <h1 class="roshd-title" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <div class="title-content" fxLayout="row" fxLayoutAlign="start center">
                <!-- <i class='bx bx-list-check'></i> -->
                <img src="../../../../../../assets/icons/Listq.svg" alt="" class="icon-height-1 icon-width-1"
                    loading="lazy" />
                <span class="font-anic"> آزمون های تمرینی تیک </span>
                <!-- <img src="../../../../../../assets/icons/Back1.svg" alt=""> -->
            </div>
        </div>
        <div class="title-dashed"></div>
    </h1>
</div>

<!-- <div  class="full-w" (click)="onLoginBottomSheet()" fxLayout="column" fxLayoutAlign="center center">
    <button class="az__green-btn login-exam-btn" mat-raised-button>
        ورود به حساب
    </button>

</div> -->
<!-- <h1 class="title">
    </h1> -->
<div fxLayout="row" fxLayoutAlign="start center">
    <mat-select class="select-bg gold filter-select" [(ngModel)]="selectedProductType" name="lessonsToggler"
        style="margin-right: 0.3rem">
        <mat-option *ngFor="let productType of productTypes" [value]="productType.id" class="font-anic"
            (click)="changeStaticFilter(productType)">
            {{ productType.title }}
        </mat-option>
    </mat-select>
    <!-- <mat-select class="select-bg gold filter-select" [(ngModel)]="selectedProductSolved" name="lessonsToggler"
        style="margin-right: 0.5rem">
        <mat-option *ngFor="let item of resolvedSolved" [value]="item.id" class="font-anic"
            (click)="changeSolvedFilter(item)">
            {{ item.title }}
        </mat-option>
    </mat-select> -->
    <div class="filters">
        <span *ngFor="let filter of filtersBookId; let i = index" (click)="changeFilter(filter.book_id, i)"
            class="filter" [class.active-filter-book]="selectedExamFitersIndex === i">{{ filter.title }}
        </span>
    </div>
</div>

<!-- <div class="exam-card-container">
    <div class="card" *ngFor="let exam of filterdUserExams">
        <div class="img-box BoughtExam">
            <img src="../../../../../../assets/img/logo.jpeg" alt="" class="logo-test">
        </div>
        <h2>{{exam?.exam_title}}</h2>
        <button *ngIf="!exam?.is_resolved && exam?.is_bought" class="exam" (click)="openExam(exam?.exam_id)">
            <img src="../../../../../../assets/icons/pen.svg" alt="" class="icon-height-1 margin-left-icon">
            <span>حل آزمون</span>
        </button>
        <button class="result" *ngIf="exam?.is_resolved && exam?.is_bought" (click)="onGoToResult(exam?.exam_id ,exam?.exam_title)">
            <img src="../../../../../../assets/icons/ReportCard.svg" alt="" class="icon-width-1 margin-left-icon">
            کارنامه
        </button>

        <button *ngIf="exam?.final_price>0 && !exam?.is_bought" class="buy" (click)="openBuyComponent(exam?.exam_id , exam?.exam_title, exam?.description)">
            <img src="../../../../../../assets/icons/Basket1.svg" alt="" class="margin-left-icon icon-width-1">
            {{exam?.final_price}} تومان
        </button>
        <button *ngIf="exam?.final_price==0 && !exam?.is_bought" class="buy" (click)="openBuyComponent(exam?.exam_id , exam?.exam_title, exam?.description)">
            <img src="../../../../../../assets/icons/Free.svg" alt="" class="margin-left-icon icon-height-1">
            رایگان
        </button>
    </div>
</div> -->

<!-- <div (click)="onLoginBottomSheet()" fxLayout="column" fxLayoutAlign="center center">
    <div class="divider2"></div>
    <button class="az__green-btn login-exam-btn" mat-raised-button>
        ورود
    </button>

</div> -->

<!-- ============================================================== -->
<!-- ====== Gift Label Test ======================================= -->


<!-- ============================================================== -->

<div class="test-card" fxLayout="row" fxLayoutAlign="start center">

    <div class="test-card-div" *ngFor="let exam of filterdUserExams; index as i">
        <div class="test-card-top">
            <img class="exam-avatar" *ngIf="!loader" [src]="chooseProductType.avatarFileId" alt="" alt=""
                loading="lazy" />
            <!-- <ngx-skeleton-loader class="skelet" appearance="circle" [count]="1" appearance="line"
                [theme]="{ height: '48px', width: '48px'}" *ngIf="loader"></ngx-skeleton-loader> -->
            <div class="title-test">
                <ngx-skeleton-loader [theme]="{ height: '48px', width: '48px'}" appearance="circle"
                    *ngIf="loader"></ngx-skeleton-loader>
                <!-- <ngx-skeleton-loader appearance="circle" *ngIf="loader"></ngx-skeleton-loader>
                <ngx-skeleton-loader appearance="circle" *ngIf="loader"></ngx-skeleton-loader> -->

                <div class="text-test-bank" #parentText>


                    <!-- <h2 *ngIf="!loader">{{ exam?.exam_title }}</h2> -->

                    <app-text-animate *ngIf="!loader" [textValue]="exam?.exam_title" [textSize]="'14px'"
                        [textWeight]="'900'">
                    </app-text-animate>


                    <p *ngIf="!loader">تیم یک رقمی های کنکور</p>
                </div>
            </div>
            <div class="date-test">
                <ngx-skeleton-loader class="skelet" [count]="2" appearance="line"
                    [theme]="{ height: '10px', width: '100px' }" *ngIf="loader"></ngx-skeleton-loader>
                <!-- <p>{{exam?.start_time | date}}</p> -->
                <div *ngIf="!loader">زمان : {{ exam?.exam_duration | farsiNumber }} دقیقه</div>

                <!-- <p *ngIf="!loader">ساعت برگزاری : {{exam?.start_time | time}}</p> -->
                <div *ngIf="exam?.question_count > 0 && !loader">   
                     سوالات : {{ exam?.question_count | farsiNumber }} تا
                </div>
            </div>
        </div>
        <!-- <button class="test-card-bottom">
            <p>ورود به آزمون</p>
            <img src="../../../../../assets/icons/pen.svg"
                class="icon-height-little icon-width-little margin-right-icon">
        </button> -->
        <!-- <ngx-skeleton-loader appearance="line" *ngIf="loader"
            [theme]="{ height: '14px', width: '130px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader appearance="line" *ngIf="loader"
            [theme]="{ height: '14px', width: '130px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader appearance="line" *ngIf="loader"
            [theme]="{ height: '14px', width: '130px' }"></ngx-skeleton-loader> -->

        <div *ngIf="!loader" class="btndiv">
            <!-- <button *ngIf="!exam?.is_resolved && exam?.is_bought" class="exam test-card-bottom"
                    (click)="openExam(exam?.exam_id)">
                    <img src="../../../../../../assets/icons/pen.svg" alt="" class="icon-height-1 margin-left-icon" />
                    <span>حل آزمون</span>
                </button> -->
            <app-tik-btn (click)="openExam(exam?.exam_id)" *ngIf="!exam?.is_resolved && exam?.is_bought"
                [btnClass]="'btn-green'" [btnLoading]="false" [btnText]="'حل آزمون'" [btnIcon]="'pen.svg'"
                fxFlex="66"></app-tik-btn>
            <!-- <button class="result test-card-bottom" *ngIf="exam?.is_resolved && exam?.is_bought"
                    (click)="onGoToResult(exam?.exam_id, exam?.exam_title)">
                    <img src="../../../../../../assets/icons/ReportCard.svg" alt=""
                        class="icon-width-1 margin-left-icon" />
                    کارنامه
                </button> -->
            <app-tik-btn (click)="onGoToResult(exam?.exam_id, exam?.exam_title, i)"
                *ngIf="exam?.is_resolved && exam?.is_bought" [btnClass]="'btn-blue'" [btnText]="'کارنامه'"
                [btnIcon]="'ReportCard.svg'" [btnLoading]="selectedIndex===i" fxFlex="66"></app-tik-btn>

            <!-- <button *ngIf="exam?.final_price > 0 && !exam?.is_bought" class="buy test-card-bottom" (click)="
                  openBuyComponent(exam?.exam_id, exam?.exam_title, exam?.description)
                ">
                    <img src="../../../../../../assets/icons/Basket1.svg" alt=""
                        class="margin-left-icon icon-width-1" />
                    {{ exam?.final_price }} تومان
                </button> -->
            <app-tik-btn *ngIf="!exam?.is_bought"
                (click)="openBuyComponent(exam?.exam_id, exam?.exam_title, exam?.description, exam?.final_price > 0)"
                [btnClass]="'btn-magenta'" [btnText]="exam?.final_price > 0 ? exam?.final_price + 'تومان'  : 'رایگان' "
                [btnIcon]=" exam?.final_price > 0 ?  'Basket1.svg':'Free.svg'" fxFlex="66"
                [btnLoading]="false"></app-tik-btn>

            <!-- <button *ngIf="exam?.final_price == 0 && !exam?.is_bought" class="buy test-card-bottom" (click)="
                 openBuyComponent(exam?.exam_id, exam?.exam_title, exam?.description)">
                    <img src="../../../../../../assets/icons/Free.svg" alt="" class="margin-left-icon icon-height-1" />
                    رایگان
                </button> -->
            <!-- <button class="desc test-card-bottom"
                    (click)="openDesctiptionBottomsheet(exam?.description,exam?.exam_title)">
                    توضیحات
                </button> -->
            <app-tik-btn (click)="openDesctiptionBottomsheet(exam?.description,exam?.exam_title)"
                [btnClass]="'btn-blue'" [btnLoading]="false" [btnText]="'توضیحات'" fxFlex="30"></app-tik-btn>
        </div>
    </div>
    <!-- <div class="full-parent-width align-center">
        <app-inline-loading [loadingShow]="loader"></app-inline-loading>
    </div> -->
    <!-- 
    <div class="full-parent-width fontb-small font-anic text-blue" style="text-align: center; cursor: pointer;"
        *ngIf=" !loader" (click)="loadmore()">
        نمایش بیشتر

    </div> -->
</div>